export default __webpack_public_path__ + "static/media/arrow-left.610dc14d.svg";